<div class="wrapper-chat-page">
    <app-chat-list class="wrapper-chat-all-conversation"
    (isNewChatActive)="setIsNewCHatActiveFlag($event)" (loadedConversations)="loadedConversations = $event" [isGroupAccountsOpen]="isGroupAccountsOpen"></app-chat-list>
    <app-chat-content class="wrapper-chat-conversation group"
    [isNewChatActive]="isNewChatActive" [loadedConversations]="loadedConversations" (isGroupAccountsOpen)="isGroupAccountsOpen = $event"></app-chat-content>
</div>
